<template>
  <div class="content-container">
    <van-nav-bar
      v-if="type==5"
      :title="$t('common.material')"
      left-arrow
      @click-left="onClickBack"
      @click-right="showUpModel"
      :right-text="$t(`actionTitles.addseats`)"
    />
    <van-nav-bar
      v-else
      :title="$t('common.material')"
      left-arrow
      @click-left="onClickBack"
      @click-right="showUpModel"
      :right-text="$t('actionTitles.uploadMaterial')"
    />
    <van-search
      v-model="name"
      :placeholder="$t('upload.searchHolder')"
      @search="onSearch"
    />
    <van-tabs v-model="type" @change="tabClick">
      <van-tab :title="$t('enum.tagType.0')" name="0">
        <div class="up-state-box" v-if="loading && loadingType == 0">
          <div class="boxs">
            <a-spin />
            <span class="m-l-5">{{ $t("upload.message.vr") }}</span>
          </div>
        </div>
        <pano-material-list ref="0" :search-key="name"></pano-material-list>
      </van-tab>

      <van-tab :title="$t('enum.materialType.4')" name="4">
        <div class="up-state-box" v-if="loading && loadingType == 4">
          <div class="boxs">
            <a-spin />
            <span class="m-l-5">{{ $t("upload.message.pic") }}</span>
          </div>
        </div>
        <material-list :type="4" ref="4" :search-key="name"></material-list>
      </van-tab>
      <!-- 直播 -->
      <van-tab :title="$t('enum.materialType.5')" name="5">
        <div class="up-state-box" v-if="loading && loadingType == 5">
          <div class="boxs">
            <a-spin />
            <span class="m-l-5">{{ $t("upload.message.pic") }}</span>
          </div>
        </div>
        <material-list :type="5" ref="5" :search-key="name" :form="form"></material-list>
      </van-tab>

      <van-tab :title="$t('enum.materialType.1')" name="1">
        <div class="up-state-box" v-if="loading && loadingType == 1">
          <div class="boxs">
            <a-spin />
            <span class="m-l-5">{{ $t("upload.message.pic") }}</span>
          </div>
        </div>
        <material-list :type="1" ref="1" :search-key="name"></material-list>
      </van-tab>
      <van-tab :title="$t('enum.materialType.2')" name="2">
        <div class="up-state-box" v-if="loading && loadingType == 2">
          <div class="boxs">
            <a-spin />
            <span class="m-l-5">{{ $t("upload.message.audio") }}</span>
          </div>
        </div>
        <material-list :type="2" ref="2" :search-key="name"></material-list>
      </van-tab>
      <van-tab :title="$t('edit.video')" name="3">
        <div class="up-state-box" v-if="loading && loadingType == 3">
          <div class="boxs">
            <a-spin />
            <span class="m-l-5">{{ $t("upload.message.video") }}</span>
          </div>
        </div>
        <material-list :type="3" ref="3" :search-key="name"></material-list>
      </van-tab>
    </van-tabs>

    <a-modal
      centered
      v-model="panoUploadVisible"
      :title="$t('message.uploadPanoImage')"
      :destroyOnClose="true"
      @ok="savePanoUpFile"
      @cancel="cancelPanoUpFile"
      keyboard
    >
      <DragUploader uptype="sourceimg" ref="panoUploader"></DragUploader>
      <template slot="footer">
        <a-button @click="cancelPanoUpFile">取消</a-button>
        <!-- 移除上傳浮水印 -->
        <!-- <a-button type="primary" @click="savePanoUpFile(1)">加浮水印上傳</a-button> -->
        <a-button type="primary" @click="savePanoUpFile(0)">普通上傳</a-button>
      </template>
    </a-modal>

    <a-modal
      centered
      v-model="upModelVisible"
      :title="$t('actionTitles.uploadMaterial')"
      :destroyOnClose="true"
      @ok="saveUpFile"
      @cancel="cancelUpFile"
      keyboard
    >
      <DragUploader ref="uploader" :uptype="uptype"></DragUploader>
    </a-modal>
    <!-- 全景視頻 -->
    <a-modal
      centered
      v-model="isShowPanoramicModal"
      :title="$t('actionTitles.uploadePanramic')"
      :destroyOnClose="true"
      @ok="savePanoramic"
      @cancel="cancelUpFile"
      keyboard
    >
      <upload-Panoramic
        ref="panoramic"
        :dir_id="dir_id"
        @refresh="tabClick"
        @cancel="cancelUpFile"
      ></upload-Panoramic>
    </a-modal>

    <!-- 全景自播 -->
    <a-modal
    centered
      :title="$t(`actionTitles.addseats`)"
      v-model="isLivePanoramicModel"
      @cancel="cancelUpFile"
      @ok="savelive"
      :destroyOnClose="true"
      v-if="this.type==5"
    >
    <upload-Panolive 
        ref="panoramiclive"
        :dir_id="dir_id"
        @refresh="tabClick"
        @cancel="cancelUpFile"
        :form="form"
    ></upload-Panolive>
    </a-modal>
    
  </div>
</template>

<style lang="less" scoped>
.up-state-box {
  padding: 0 10px;
  .boxs {
    width: 100%;
    padding: 15px;
    border-radius: 4px;
    background-color: rgba(10, 103, 251, 0.02);
    display: flex;
    align-items: center;
    .m-l-5 {
      margin-left: 10px;
      color: #0a67fb;
      font-size: 12px;
    }
  }
}
.content-container {
  background-color: #fff;
  min-height: 100vh;
}

.material-wrapper {
  padding: 0px 10px 0px 10px;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .info-wrapper {
    padding: 10px 0 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 0.5px solid #efeeee;
    .material-info {
      margin-left: 10px;
    }
    .info-title {
      font-size: 1rem;
      color: rgba(0, 0, 0, 1);
      font-weight: 100;
    }
    .info-description {
      font-size: 0.8rem;
      color: gray;
    }
  }
}
</style>

<script>
import Vue from "vue";
import {
  Cell,
  CellGroup,
  List,
  PullRefresh,
  Search,
  Button,
  NavBar,
  Tab,
  Tabs,
  Checkbox,
} from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List);
Vue.use(Search);
Vue.use(PullRefresh);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);

import "../../../assets/css/mobile.less";
import { mapGetters } from "vuex";

import PanoMaterialList from "./components/PanoMaterialList";
import MaterialList from "./components/MaterialList";
import DragUploader from "@/components/DragUploader";
import uploadPanoramic from "@/components/UploadPanoramic";

import { materialAdd } from "@/api/planeMaterial";
import { addPano } from "@/api/material";
import UploadPanolive from "@/components/UploadPanolive";

export default {
  components: { PanoMaterialList, MaterialList, DragUploader, uploadPanoramic,UploadPanolive },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      name: "",
      type: "0",
      upModelVisible: false,
      uptype: "pic",
      panoUploadVisible: false,
      replace_id: 0,
      dir_id: 0,
      loading: false,
      loadingType: 0,
      isShowPanoramicModal: false,
      isLivePanoramicModel:false,
      form: {

      },
    };
  },
  watch: {
    type(value) {
      if (value == 1) {
        this.uptype = "pic";
      } else if (value == 2) {
        this.uptype = "audio";
      } else if (value == 3) {
        this.uptype = "video";
      }
    },
  },
  created() {},
  mounted() {
    this.type = "" + this.$route.query.type;
    this.$nextTick(() => {
      this.$refs[this.type].onRefresh();
    });
  },
  methods: {
    onClickBack() {
      this.$router.back();
    },
    showUpModel() {
      let dir = this.$refs[this.type].folderDepthList;
      this.dir_id = dir.length ? dir[dir.length - 1]["id"] : 0;
      if (this.type == 0) {
        this.panoUploadVisible = true;
      } else if (this.type == 4) {
        this.isShowPanoramicModal = true;
      } else if(this.type == 5) {
        this.isLivePanoramicModel = true;
      }
      else {
        this.upModelVisible = true;
      }
    },
    cancelUpFile() {
      if (this.upModelVisible) {
        this.upModelVisible = false;
        this.$refs.uploader.delFile();
      } else if(this.isShowPanoramicModal){
        this.isShowPanoramicModal = false;
        this.$refs.panoramic.init();
      }
      else if(this.isLivePanoramicModel){
        this.isLivePanoramicModel = false
        // this.$refs.panoramiclive.init();
      }
    },
    saveUpFile() {
      let _this = this;
      let list = this.$refs.uploader.fileList;
      if (this.$refs.uploader.completed == true && list.length > 0) {
        //組裝傳給服務端的數據
        let imgs = [];
        for (var i = 0; i < list.length; i++) {
          let tmp = {
            name: list[i].name,
            url: list[i].url,
            filesize: list[i].filesize,
            type: _this.type,
            dir_id: this.dir_id,
          };
          imgs.push(tmp);
        }
        this.cancelUpFile();
        this.loading = true;
        this.loadingType = _this.type;
        materialAdd(imgs).then((res) => {
          console.log("res", res);
          if (res.code == 1) {
            this.loading = false;
            this.$message.success(this.$i18n.t("message.saveSuccess"));
            console.log("this.type", this.type);
            this.$refs[this.type].onRefresh();
          }
        });
      }
    },
    //@param is_water: 是否加水印
    savePanoUpFile(is_water) {
      let _this = this;
      let list = this.$refs.panoUploader.fileList;
      if (this.$refs.panoUploader.completed == true && list.length > 0) {
        //防止界面卡住重復上傳
        if(!this.panoUploadVisible){
          return;
        }
        //組裝傳給服務端的數據
        let imgs = [];
        for (var i = 0; i < list.length; i++) {
          let tmp = {
            imgname: list[i].name,
            imgsrc: list[i].key,
            filesize: list[i].filesize,
          };
          imgs.push(tmp);
        }
        this.cancelPanoUpFile();
        this.loading = true;
        this.loadingType = 0;
        addPano({
          replace_id: _this.replace_id,
          imgs: imgs,
          dir_id: this.dir_id,
          is_water: is_water,
        }).then((res) => {
          console.log("res", res);
          if (res.code === 1) {
            this.loading = false;
            this.$message.success(this.$i18n.t("message.saveSuccess"));
            console.log("this.type", this.type);
            this.$refs[this.type].onRefresh();
          }
        });
      }
    },
    cancelPanoUpFile() {
      this.panoUploadVisible = false;
      this.$refs.panoUploader.delFile();
    },
    onSearch() {
      this.$refs[this.type].onRefresh();
    },
    tabClick() {
      this.$nextTick(() => {
        this.$refs[this.type].onRefresh();
      });
    },
    //全景視頻
    savePanoramic() {
      this.$refs.panoramic.savePanoramic();
    },
    // 全景自播
    savelive() {
      if(this.form.dir_id == undefined){
        this.$refs.panoramiclive.savePanoramic();
      }else{
        this.cancelUpFile();
      rename(this.form).then((res) => {
              this.$message.success(this.$t("message.saveSuccess"));
              this.exitModel = false;
              this.loadData();
            });
      }
      
    },
  },
};
</script>

